import VideoScanner from "./VideoScanner";

export default VideoScanner;
